$(window).on('resize scroll', function () {
	if ($('body').hasClass('partner_long')) {
		if ($(window).scrollTop() > 140) $('body').addClass('partner_long_'); else $('body').removeClass('partner_long_');
	}
});